import { fetcher } from '@commenda/utils';

export interface RequestComplianceItemExtensionArgs {
  /** Optional free-text note from the client. Appended to the chat-room message
   * that the backend posts into the linked service-request thread. */
  note?: string;
}

interface RequestComplianceItemExtensionResponse {
  success: boolean;
}

export async function requestComplianceItemExtension(
  complianceItemId: string,
  body: RequestComplianceItemExtensionArgs = {}
): Promise<RequestComplianceItemExtensionResponse> {
  const res = await fetcher(
    `compliance/${complianceItemId}/request-extension`,
    {
      method: 'POST',
      body,
    }
  );

  if (!res.ok) {
    return { success: false };
  }
  return { success: true };
}
